/* eslint-disable react/forbid-prop-types */
import P from 'prop-types';
import { NumericFormat } from 'react-number-format';
import { InputAdornment } from '@material-ui/core';
import { FormGroup } from '../styles';
import { TextField, AutocompleteField } from '../../FormFields';

export function AutoQuestions({
    insuranceAutoCarColor,
    insuranceAutoCarNF,
    insuranceAutoCarSoldDate,
    insuranceAutoCarFabricante,
    insuranceAutoCarFamilia,
    insuranceAutoCarModelo,
    insuranceAutoCarPlate,
    insuranceAutoCarSaleValue,
    insuranceAutoCarAnoFabricacao,
    insuranceAutoCarAnoModelo,
    insuranceAutoCarVendedor,
    insuranceAutoCarCpfVendedor,
    insuranceFormaPagto,
    onChange,
    onChangeAutoComplete,
    onChangeNumeric
})
{
    
    return (
        <>
        <FormGroup dark>
            <TextField
                value={insuranceAutoCarFabricante || ''}
                onChange={onChange}
                varibleName="insurance_auto_car_fabricante"
                placeholder="Fabricante"
                className="control ms"
                label="Fabricante"
            />
            <TextField
                value={insuranceAutoCarFamilia || ''}
                onChange={onChange}
                varibleName="insurance_auto_car_familia"
                placeholder="Família"
                className="control ms"
                label="Família"
            />
            <TextField
                value={insuranceAutoCarModelo || ''}
                onChange={onChange}
                varibleName="insurance_auto_car_modelo"
                placeholder="Modelo"
                className="control ms"
                label="Modelo"
            />
            <TextField
                value={insuranceAutoCarPlate || ''}
                onChange={onChange}
                varibleName="insurance_auto_car_plate"
                placeholder="Placa"
                className="control ms"
                label="Placa"
            />
        </FormGroup>

        <FormGroup dark>
        <TextField
                value={insuranceAutoCarColor || ''}
                onChange={onChange}
                varibleName="insurance_auto_car_color"
                placeholder="Cor"
                className="control ms"
                label="Cor"
            />
            <TextField
                value={insuranceAutoCarAnoFabricacao || ''}
                onChange={onChange}
                varibleName="insurance_auto_car_ano_fabricacao"
                placeholder="Ano de Fabricação"
                className="control ms"
                label="Ano de Fabricação"
            />
            <TextField
                value={insuranceAutoCarAnoModelo || ''}
                onChange={onChange}
                varibleName="insurance_auto_car_ano_modelo"
                placeholder="Ano do Modelo"
                className="control ms"
                label="Ano do Modelo"
            />
        </FormGroup>
        <FormGroup dark>
            <NumericFormat
                label="Valor de venda"
                customInput={TextField}
                decimalSeparator=","
                decimalScale={2}
                autoComplete="off"
                InputProps={{
                    startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                }}
                value={insuranceAutoCarSaleValue}
                onChange={onChangeNumeric}
            />
            <TextField
                value={insuranceAutoCarNF || ''}
                onChange={onChange}
                varibleName="insurance_auto_car_nf"
                placeholder="Nota fiscal"
                className="control ms"
                label="Nota fiscal"
            />
            <TextField
                value={insuranceAutoCarSoldDate || ''}
                type='date'
                onChange={onChange}
                varibleName="insurance_auto_car_sold_date"
                placeholder="Data da Venda"
                className="control ms"
                label="Data da Venda"
            />
            <TextField
                value={insuranceFormaPagto || ''}
                onChange={onChange}
                varibleName="insurance_forma_pagto"
                placeholder="Forma de pagamento"
                className="control ms"
                label="Forma de pagamento"
            />            
        </FormGroup>
        <FormGroup dark>
            <TextField
                value={insuranceAutoCarVendedor || ''}
                onChange={onChange}
                varibleName="insurance_auto_car_vendedor"
                placeholder="Nome do Vendedor"
                className="control ms"
                label="Nome do Vendedor"
            />
            <TextField
                value={insuranceAutoCarCpfVendedor || ''}
                onChange={onChange}
                varibleName="insurance_auto_car_cpf_vendedor"
                placeholder="Cpf do Vendedor"
                className="control ms"
                label="Cpf do Vendedor"
            />
        </FormGroup>
        </>
    )
};

AutoQuestions.propTypes = {
    insuranceAutoCarColor: P.string.isRequired,
    insuranceAutoCarNF: P.string.isRequired,
    insuranceAutoCarSoldDate: P.string.isRequired,
    insuranceAutoCarFabricante: P.string.isRequired,
    insuranceAutoCarFamilia: P.string.isRequired,
    insuranceAutoCarModelo: P.string.isRequired,
    insuranceAutoCarPlate: P.string.isRequired,
    insuranceAutoCarSaleValue: P.string.isRequired,
    insuranceAutoCarAnoFabricacao: P.string.isRequired,
    insuranceAutoCarAnoModelo: P.string.isRequired,
    insuranceAutoCarVendedor: P.string.isRequired,
    insuranceAutoCarCpfVendedor: P.string.isRequired,
    insuranceFormaPagto: P.string.isRequired,
    onChange: P.objectOf(P.any).isRequired,
    onChangeAutoComplete: P.objectOf(P.any).isRequired,
    onChangeNumeric: P.objectOf(P.any).isRequired,
}

AutoQuestions.defaultProps = {
    
}